import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CHeader,
  CHeaderText,
  CModal,
  CModalBody,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import authInstance from "src/api/apiConfig";
import { getAllAccount, getAllEntries } from "src/redux/accounting/action";
import { Loader } from "src/services/const";
import { formatDate } from "src/services/helpers";
import { errorAlert, successAlert } from "src/utils/Swal";

const JEntryData = () => {
  const dispatch = useDispatch();
  const componentPDF = useRef();
  const handleSearch = () => { };
  const [printState, setPrintState] = useState(false);
  const { journalData, allAccountData } = useSelector((state) => state?.acountingReducer);
  const [selectedDebitAccount, setSelectedDebitAccount] = useState({
    id: "",
    accountName: "",
  });
  const [addModal, setAddModal] = useState(false);
  const branchId = JSON.parse(sessionStorage.getItem("branc"));
  const schemaName = sessionStorage.getItem("schemaName");
  useEffect(() => {
    const data = {
      schemaName: schemaName,
    };
    dispatch(getAllEntries(data));
  }, []);
  const initialValues = {
    debitAmount: 0,
    creditAmount: 0,
    debitAccount: "",
    creditAccount: "",
    narration: "",
    entryDate: "",
    schemaName: schemaName,
    branchId: branchId,
  };

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "userData",
    onAfterPrint: () => setPrintState(false),
  });
  useEffect(() => {
    if (printState) {
      generatePDF();
    }
  }, [printState]);
  const handlePrint = () => {
    setPrintState(true);
  };

  const handleAdd = () => {
    setAddModal(true);
  };

  const [formValues, setFormValues] = useState(initialValues);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevData) => ({ ...prevData, [name]: value }));
  };
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [loader, setLoader] = useState(false);
  const {
    entryDate,
    debitAmount,
    debitAccount,
    creditAccount,
    creditAmount,
    narration,
  } = formValues;
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...formValues,
      creditAmount: debitAmount,
      debitAccountId: null,
      creditAccountId: null,
      debitAccount: selectedDebitAccount?.accountName,
    };
    if (
      !entryDate ||
      !debitAmount ||
      !debitAccount ||
      !creditAccount ||
      !narration
    ) {
      errorAlert("Opps", "please fill all the fields!!");
      return;
    }
    setLoader(true);
    try {
      const response = await authInstance.post("addJournal", payload);
      if (response.status === 201) {
        successAlert("Success", "Journal Entry Successfully Added");
        const obj = {
          schemaName: schemaName,
        };
        dispatch(getAllAccount(obj));
        setAddModal(false);
      }
      setFormValues(initialValues);
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const setDebitAccountValue = (e) => {
    const selectedValue = e.target.value;

    const selectedAccount = allAccountData?.data?.find(
      (item) => item?.accountName === selectedValue
    ) || { id: "", accountName: "" };
    setSelectedDebitAccount(selectedAccount);
  };

  return (
    <div className="content">
      <CModal visible={addModal} onClose={() => setAddModal(false)}>
        <CHeader>
          <CHeaderText> Expenses Entries</CHeaderText>
        </CHeader>
        <CModalBody>
          <CCardBody>
            <CForm onSubmit={(e) => handleSubmit(e)}>
              <CRow className="ad_row">
                <CCol xs={6}>
                  <CFormLabel>Select Date</CFormLabel>
                  <CFormInput
                    type="date"
                    placeholder="Select A Date"
                    value={entryDate}
                    name="entryDate"
                    onChange={handleChange}
                  />
                </CCol>
                <CCol xs={5}>
                  <CFormLabel className="custom-form-label">
                    Enter Account
                  </CFormLabel>
                  <CFormSelect
                    type="text"
                    placeholder="Enter Account Name"
                    required
                    value={selectedDebitAccount.accountName}
                    onChange={(e) => setDebitAccountValue(e)}
                  // className="custom-form-input"
                  >
                    <option value="">Select Accounts</option>
                    {allAccountData?.data
                      ?.filter((ele) => ele?.debitCredit === "debit")
                      ?.map((item, i) => (
                        <option key={i} value={item.accountName}>
                          {item?.accountName?.toUpperCase()}
                        </option>
                      ))}
                  </CFormSelect>
                </CCol>
              </CRow>
              <CRow className="ad_row">
                <CCol xs={6}>
                  <CFormLabel>Enter Amount</CFormLabel>
                  <CFormInput
                    type="number"
                    placeholder="Enter Amount"
                    required
                    name="debitAmount"
                    value={debitAmount}
                    onChange={handleChange}
                  />
                </CCol>
                <CCol xs={6}>
                  <div className="mb-3">
                    <label>Select Account</label>
                    <select
                      name="creditAccount"
                      className="form-control white-border"
                      value={creditAccount}
                      onChange={handleChange}
                    >
                      <option value="">-- Select Exit Type --</option>
                      <option value="Cash">Cash</option>
                      <option value="Bank">Bank</option>
                      <option value="Suspense">Suspense</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol>
                  <CFormLabel>Enter Narration</CFormLabel>
                  <CFormTextarea
                    type="text"
                    placeholder="Enter Narration"
                    value={narration}
                    name="narration"
                    onChange={handleChange}
                    required
                  />
                </CCol>
              </CRow>
              <div
                style={{ marginTop: "20px" }}
                className="d-flex justify-content-between"
              >
                <CButton
                  style={{
                    padding: "5px 7px",
                    background: "linear-gradient(181deg, #000208, #333)",
                  }}
                  onClick={() => setAddModal(false)}
                >
                  Close
                </CButton>
                {loader ? (
                  <Loader />
                ) : (
                  <CButton
                    style={{
                      padding: "5px 7px",
                      background: "linear-gradient(181deg, #000208, #333)",
                    }}
                    type="submit"
                  >
                    Save
                  </CButton>
                )}
              </div>
            </CForm>
          </CCardBody>
        </CModalBody>
      </CModal>
      <CCard>
        <CCardHeader className="d-flex justify-content-between align-items-center">
          <strong>Expenses List</strong>
          <div style={{ display: "flex", gap: "10px" }}>
            <div className="d-flex gap-2">
              <input
                type="date"
                placeholder="start date"
                value={start_date}
                onChange={(e) => setStart_date(e.target.value)}
                className="form-control"
                style={{ width: "180px" }}
              />
            </div>
            <div className="d-flex gap-2">
              <input
                type="date"
                placeholder="end date"
                value={end_date}
                onChange={(e) => setEnd_date(e.target.value)}
                className="form-control"
                style={{ width: "180px" }}
              />
            </div>
            <CButton
              style={{
                padding: "5px 7px",
                background: "linear-gradient(181deg, #000208, #333)",
              }}
              onClick={handleSearch}
            >
              Search
            </CButton>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <CButton
              onClick={handleAdd}
              style={{
                padding: "5px 7px",
                background: "linear-gradient(181deg, #000208, #333)",
              }}
            >
              + New
            </CButton>
            {/* <CButton
              onClick={handlePrint}
              style={{
                padding: "5px 7px",
                background: "linear-gradient(181deg, #000208, #333)",
              }}
            >
              Download
            </CButton> */}
          </div>
        </CCardHeader>
        <CCardBody
          className="new-common-table-wrapper new-table-container"
        // style={{ maxHeight: "700px" }}
        >
          <CTable className="custom-tablee" borderless>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">Date</CTableHeaderCell>
                <CTableHeaderCell scope="col" className="col-md-5">
                  Particulars
                </CTableHeaderCell>
                <CTableHeaderCell scope="col">J.F</CTableHeaderCell>
                <CTableHeaderCell scope="col">Amount(Dr.)</CTableHeaderCell>
                <CTableHeaderCell scope="col">Amount(Cr.)</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {journalData?.map((value, i) => (
                // console.log("value", value)
                <CTableRow key={i}>
                  <CTableDataCell>
                    {formatDate(value?.entryDate)}
                  </CTableDataCell>
                  <CTableDataCell>
                    <div className="entry_data">
                      <div className="draw">
                        <span>{value?.debitAccount} A/c</span>
                        <span>Dr.</span>
                      </div>
                      <div className="to_cash">
                        <span>To </span>
                        <span>{value?.creditAccount} A/c</span>
                      </div>
                      <div>
                        <span>({value?.narration})</span>
                      </div>
                    </div>
                  </CTableDataCell>
                  <CTableDataCell></CTableDataCell>
                  <CTableDataCell>
                    <div className="entry_data">
                      <div className="draw"></div>
                      <div className="to_pur">
                        <span>{value?.debitAmount}</span>
                      </div>
                    </div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div className="entry_data">
                      <div className="draw"></div>

                      <div className="to_cas">
                        <span>{value?.creditAmount}</span>
                      </div>
                    </div>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </CCardBody>
      </CCard>
    </div>
  );
};

export default JEntryData;
